import { ColumnData, ProductAlertForm, ViewMode } from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { ProductsBase } from './products';

export const ProductAlertCreate = () => {
  const { productId } = useParams<{ productId: string }>();
  const navigate = useNavigate();

  if (!productId) return null;

  const rightColumn: ColumnData = {
    title: 'alerts.setAlert',
    mainComponent: (
      <ProductAlertForm
        productId={productId}
        onClose={() => navigate('/products')}
      />
    ),
    showBackButton: true,
    onBackButtonPress: () => navigate('/products'),
    disableScroll: true,
  };

  return <ProductsBase rightColumn={rightColumn} viewMode={ViewMode.DUAL} />;
};
